(function() {
  function track(panel) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: panel === 'consult' ? 'consult_open' : panel + '_open',
      action_hub_panel: panel
    });
    window.dataLayer.push({
      event: 'action_hub_open',
      action_hub_panel: panel
    });
  }

  function trackFallback(panel) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'action_hub_fallback',
      action_hub_panel: panel
    });
  }

  function extractDrawerContent(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var main = parsed.querySelector('main#main') || parsed.querySelector('main');
    if (!main) return '';

    var sections = Array.prototype.slice.call(main.children).filter(function(section) {
      return !section.classList.contains('shopify-section-group-footer-group');
    });

    return sections.map(function(section) {
      return '<section class="ichika-action-drawer__section">' + section.innerHTML + '</section>';
    }).join('');
  }

  function prepareContent(drawer, panel) {
    var wrapper = drawer.querySelector('[data-ichika-drawer-content-wrap]');
    var content = drawer.querySelector('[data-ichika-drawer-content]');
    var error = drawer.querySelector('[data-ichika-drawer-error]');
    if (!wrapper || !content || wrapper.dataset.loadState) return;

    wrapper.dataset.loadState = 'loading';
    if(panel==='wishlist'){
      fetch('/apps/ichika/wishlist',{headers:{Accept:'application/json'}}).then(async function(response){
        if(response.status===401){var items=[];try{for(var i=0;i<localStorage.length;i++){var key=localStorage.key(i);if(key&&key.indexOf('ichika-wishlist:')===0){try{var item=JSON.parse(localStorage.getItem(key));if(item&&typeof item.title==='string')items.push(item);}catch{}}}}catch{}return {items:items,guest:true};}
        if(!response.ok)throw new Error();return response.json();
      }).then(function(data){
        content.replaceChildren();var summary=document.createElement('p');summary.textContent=data.items.length+'件のお気に入り'+(data.guest?'（この端末）':'');content.append(summary);
        data.items.slice(0,3).forEach(function(item){var card=document.createElement('article');card.style.cssText='display:flex;gap:14px;padding:20px 0;border-bottom:1px solid #e6e4dd';
          if(item.product_image_url){try{var src=new URL(item.product_image_url,location.origin);if(src.origin===location.origin||src.protocol==='https:'&&src.hostname==='cdn.shopify.com'){var image=document.createElement('img');image.src=src.href;image.alt=item.title;image.width=88;image.height=88;image.style.cssText='width:88px;height:88px;object-fit:cover';card.append(image);}}catch{}}
          var title=document.createElement('p');title.textContent=item.title;title.style.cssText='font-size:14px;line-height:1.7;margin:0';card.append(title);content.append(card);
        });content.dataset.wishlistHelpState=data.items.length?'filled':'empty';
        var footer=drawer.querySelector('[slot="footer"]');if(footer){footer.href=data.items.length?'/pages/wishlist':'/pages/wishlist?view=wishlist-help#save';footer.textContent=data.items.length?'すべてのお気に入りを見る':'はじめての使い方を見る';}
        wrapper.dataset.loadState='loaded';wrapper.classList.add('is-loaded');
      }).catch(function(){delete wrapper.dataset.loadState;wrapper.classList.add('is-error');if(error)error.hidden=false;});return;
    }
    if (panel === 'reviews') {
      fetch('/apps/ichika/reviews?kind=all', {headers: {Accept: 'application/json'}})
        .then(function(response) { if (!response.ok) throw new Error('reviews_failed'); return response.json(); })
        .then(function(data) {
          content.replaceChildren();
          var summary=document.createElement('p');summary.textContent='レビュー '+data.total+'件 ｜ 平均 '+(data.average==null?'—':Number(data.average).toFixed(1))+' / 5';summary.style.cssText='color:#126b69;text-align:center;padding:4px 0 18px';content.append(summary);
          data.reviews.slice(0, 3).forEach(function(review) {
            var card = document.createElement('article');
            card.style.cssText = 'padding:20px 0;border-bottom:1px solid #e6e4dd;display:flow-root';
            if (review.product_image_url) {
              var image = document.createElement('img');
              image.src = review.product_image_url;
              image.alt = review.product_title || '過去の商品';
              image.width = 88; image.height = 88;
              image.style.cssText = 'width:88px;height:88px;object-fit:cover;float:left;margin:0 12px 8px 0';
              card.append(image);
            }
            [review.product_title || 'ショップレビュー', '★'.repeat(Math.max(0, Math.min(5, review.rating))) + '　匿名　'+new Intl.DateTimeFormat('ja-JP').format(new Date(review.created_at)), review.body].forEach(function(value,index) {
              var paragraph = document.createElement('p');
              paragraph.textContent = value;
              paragraph.style.cssText = 'margin:0 0 8px;white-space:pre-wrap;overflow-wrap:anywhere';
              if(index===0)paragraph.style.cssText+=';font-size:13px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden';
              if(index===1)paragraph.style.cssText+=';clear:both;color:#ad8c4b;font-size:12px;padding-top:8px';
              if(index===2)paragraph.style.cssText+=';font-size:14px;line-height:1.8;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden';
              card.append(paragraph);
            });
            content.append(card);
          });
          if (!data.reviews.length) content.textContent = '掲載中のレビューはありません。';
          wrapper.dataset.loadState = 'loaded';
          wrapper.classList.add('is-loaded');
        }).catch(function() {
          delete wrapper.dataset.loadState;
          wrapper.classList.add('is-error');
          if (error) error.hidden = false;
        });
      return;
    }
    fetch(wrapper.getAttribute('data-src'), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function(response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text();
    }).then(function(html) {
      var extracted = extractDrawerContent(html);
      if (!extracted) throw new Error('Drawer content was empty');
      content.innerHTML = extracted;
      wrapper.dataset.loadState = 'loaded';
      wrapper.classList.add('is-loaded');
      document.dispatchEvent(new CustomEvent('shopify:section:load', {
        detail: { sectionId: drawer.id }
      }));
    }).catch(function() {
      wrapper.dataset.loadState = 'error';
      wrapper.classList.add('is-error');
      if (error) error.hidden = false;
      trackFallback(panel);
    });
  }

  function open(panel) {

    var drawer = document.getElementById('ichika-' + panel + '-drawer');
    if (!drawer) return false;
    if (panel === 'reviews') {
      var footer = drawer.querySelector('[slot="footer"]');
      if (footer) footer.textContent = 'すべてのレビューを見る';
    }
    if(panel==='wishlist'){var wrap=drawer.querySelector('[data-ichika-drawer-content-wrap]');if(wrap&&wrap.dataset.loadState!=='loading'){delete wrap.dataset.loadState;wrap.classList.remove('is-error');var error=drawer.querySelector('[data-ichika-drawer-error]');if(error)error.hidden=true;}var footer=drawer.querySelector('[slot="footer"]');if(footer)footer.textContent='すべてのお気に入りを見る';}
    prepareContent(drawer, panel);
    if (typeof drawer.show === 'function') {
      drawer.show();
    } else {
      drawer.setAttribute('open', '');
    }
    track(panel);
    return true;
  }

  window.IchikaActionDrawers = {
    open: open,
    track: track
  };
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('.ichika-desktop-support-nav a[href="/pages/reviews"], .ichika-mobile-bottom-nav a[href="/pages/reviews"], [data-ichika-support-action="reviews"], [data-ichika-mobile-action="reviews"], .ichika-desktop-support-nav a[href="/pages/wishlist"], .ichika-mobile-bottom-nav a[href="/pages/wishlist"], [data-ichika-support-action="wishlist"], [data-ichika-mobile-action="wishlist"]');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var panel=(trigger.getAttribute('href')||trigger.dataset.ichikaSupportAction||trigger.dataset.ichikaMobileAction||'').includes('wishlist')?'wishlist':'reviews';
    if (open(panel)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
})();

(function(){
  let accountItems=[],guest=true,ready=false;
  const localItems=()=>{const items=[];try{for(let i=0;i<localStorage.length;i++){const key=localStorage.key(i);if(key?.startsWith('ichika-wishlist:')){try{const item=JSON.parse(localStorage.getItem(key));if(item?.handle)items.push({...item,key});}catch{}}}}catch{}return items;};
  const saved=handle=>(guest?localItems():accountItems).find(item=>item.handle===handle);
  function sync(){document.querySelectorAll('[data-ichika-card-wishlist]').forEach(button=>{const item=saved(button.dataset.handle);button.setAttribute('aria-pressed',String(Boolean(item)));button.textContent=item?'♥':'♡';button.setAttribute('aria-label',item?'お気に入りに保存済み':'お気に入りに追加');button.disabled=!ready;});}
  function install(){document.querySelectorAll('product-card[handle]').forEach(card=>{
    if(card.querySelector('[data-ichika-card-wishlist]'))return;
    const handle=card.getAttribute('handle');if(!/^[a-z0-9][a-z0-9-]*$/.test(handle))return;
    const figure=card.querySelector('.product-card__figure');if(!figure)return;
    const button=document.createElement('button');button.type='button';button.dataset.ichikaCardWishlist='';button.dataset.handle=handle;button.className='ichika-card-heart';
    const message=document.createElement('p');message.className='ichika-card-message';message.setAttribute('role','status');card.append(message);figure.append(button);
    button.addEventListener('click',async event=>{event.preventDefault();event.stopPropagation();button.disabled=true;message.textContent='';try{
      const existing=saved(handle);
      if(existing){
        if(guest)localStorage.removeItem(existing.key);
        else if(existing.list_id){location.href='/pages/wishlist';return;}
        else{const url=new URL('/apps/ichika/wishlist',location.origin);url.searchParams.set('product',String(existing.product).replace('gid://shopify/Product/',''));url.searchParams.set('variant',String(existing.variant||'').replace('gid://shopify/ProductVariant/',''));const response=await fetch(url,{method:'DELETE',headers:{Accept:'application/json'}});if(!response.ok)throw new Error();accountItems=accountItems.filter(item=>item!==existing);}
        message.textContent='お気に入りから外しました。';
      }else{
        const response=await fetch('/products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}});if(!response.ok)throw new Error();const product=await response.json();
        if(product.variants.length!==1){location.href='/products/'+encodeURIComponent(handle);return;}
        const variant=product.variants[0];const item={product:String(product.id),variant:String(variant.id),title:product.title,handle,available:product.available,variant_title:variant.title,product_image_url:product.featured_image,saved_at:new Date().toISOString()};
        if(guest)localStorage.setItem('ichika-wishlist:'+product.id,JSON.stringify(item));
        else{const url=new URL('/apps/ichika/wishlist',location.origin);url.searchParams.set('product',item.product);url.searchParams.set('variant',item.variant);url.searchParams.set('product_handle',handle);const result=await fetch(url,{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:'{}'});if(!result.ok)throw new Error();accountItems.push({...item,product:'gid://shopify/Product/'+item.product,variant:'gid://shopify/ProductVariant/'+item.variant,list_id:''});}
        message.textContent='お気に入りに保存しました。';
      }
      document.dispatchEvent(new CustomEvent('ichika:wishlist-changed'));
    }catch{message.textContent='保存状態を変更できませんでした。再度お試しください。';}finally{sync();}});
  });sync();}
  fetch('/apps/ichika/wishlist',{headers:{Accept:'application/json'}}).then(async response=>{if(response.status===401){guest=true;}else{if(!response.ok)throw new Error();guest=false;accountItems=(await response.json()).items;}ready=true;sync();}).catch(()=>{});
  install();let pending=false;new MutationObserver(()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;if(document.querySelector('product-card[handle]:not(:has([data-ichika-card-wishlist]))'))install();});}).observe(document.body,{childList:true,subtree:true});
  addEventListener('storage',()=>{if(guest)sync();});document.addEventListener('ichika:wishlist-changed',sync);
})();
